import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Container,
  CircularProgress,
  Alert,
  Stack,
  Divider,
} from '@mui/material';
import { useCompanies } from '../hooks/useCompanies';

const CampaignList = () => {
  const navigate = useNavigate();

  const { companies, error, isLoading } = useCompanies();

  const handleCampaignRegister = (companyId) => {
    navigate(`/campaign-register/${companyId}`);
  };

  const handleViewCampaigns = (companyId, companyName) => {
    navigate(
      `/companies/${companyId}?companyName=${encodeURIComponent(companyName)}`
    );
  };

  if (isLoading) {
    return (
      <Container
        maxWidth="md"
        sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="error">
          企業データの取得に失敗しました: {error.message}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          border: '2px solid #333',
          backgroundColor: '#fff',
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            mb: 3,
            pb: 1,
            borderBottom: '2px solid #12c462',
            fontWeight: 'bold',
          }}
        >
          企業管理
        </Typography>

        {!companies || companies.length === 0 ? (
          <Typography variant="body1" color="text.secondary">
            企業データがありません
          </Typography>
        ) : (
          <Box
            sx={{
              maxHeight: 500,
              overflowY: 'auto',
              pr: 2,
            }}
          >
            {companies.map((company, index) => (
              <Box key={company.id}>
                <Box sx={{ py: 3 }}>
                  <Typography variant="h6" component="h3" sx={{ mb: 2 }}>
                    {company.company_name}
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ width: '100%', justifyContent: 'space-evenly' }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => navigate(`/plan-registar/${company.id}`)}
                      sx={{
                        borderRadius: 1,
                        minWidth: 200,
                        backgroundColor: '#12c462',
                      }}
                    >
                      プラン登録
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        navigate(
                          `/plans/${company.id}?companyName=${encodeURIComponent(company.company_name)}`
                        )
                      }
                      sx={{
                        borderRadius: 1,
                        minWidth: 200,
                      }}
                    >
                      プラン一覧
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleCampaignRegister(company.id)}
                      sx={{
                        borderRadius: 1,
                        minWidth: 200,
                        backgroundColor: '#12c462',
                      }}
                    >
                      キャンペーン登録
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        handleViewCampaigns(company.id, company.company_name)
                      }
                      sx={{
                        borderRadius: 1,
                        minWidth: 200,
                      }}
                    >
                      キャンペーン一覧
                    </Button>
                  </Stack>
                </Box>
                {index < companies.length - 1 && <Divider />}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default CampaignList;
